import sam from "../../Assets/newAsset/imaging/sam.webp";
import { useLocation } from "react-router";
import { MdLocationOn } from "react-icons/md";
import { RiArrowDropDownLine } from "react-icons/ri";
// import "../../../src/Pages/homePage/Components/Content.css";
import cart_empty from "../../Assets/cart_empty.svg";
import cart_fill from "../../Assets/cart_fill.svg";
import { Link, NavLink, useHistory } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import {
  getAddressImagingPackageList,
  getCity,
  setCity,
  setImgCenterAddress,
  AddtoCart,
  getCartDetails,
} from "../../Redux/Actions";
// import  "../../Pages/HealthPackagePage/Component/"
import { useState, useEffect } from "react";
import { useSelector, connect, useDispatch } from "react-redux";

import "./AddressPopUp.css";
//Location DATA

const locationData = [
  {
    id: 1,
    title: "Apollo Hospital",

    listDesc: "007, Venice Beach, Omaha Estate, 4212",

    offer_price: "650",
    isPremium: false,
    city: "city1",
  },
  {
    id: 2,
    title: "Apollo Hospital",

    listDesc: "007, Venice Beach, Omaha Estate, 4212",

    offer_price: "650",
    isPremium: false,
    city: "city1",
  },
  {
    id: 3,
    title: "Apollo Hospital",
    listDesc: "007, Venice Beach, Omaha Estate, 4212",
    offer_price: "650",
    isPremium: false,
    city: "city1",
  },
  {
    id: 4,
    title: "Apollo Hospital",

    listDesc: "007, Venice Beach, Omaha Estate, 4212",

    offer_price: "650",
    isPremium: false,
    city: "city1",
  },
];

export const AddressPopUp = (props) => {
  const { slug, City, Close, fromCart, cartId } = props;
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const dispatch = useDispatch();

  const [radioVal, setRadioVal] = useState("");
  const history = useHistory();
  const [displayCityList, setDisplay] = useState(true);
  const [userCity, setUserCity] = useState("");
  const [cityValue, setCityValue] = useState("");
  useEffect(() => {
    props.getAddress(props.slug, props.SelCity);
  }, [props.slug, props.SelCity]);

  useEffect(() => {
    dispatch(getCity());
  }, []);

  useEffect(() => {
    if (props.SelAddress.address && props.Address && props.Address.length > 0) {
      let newArray = [];
      props.Address.forEach((item) => {
        newArray.push(item?.center?.address);
      });
      if (!newArray.includes(props.SelAddress.address)) {
        alert("Not available at selected address");
        Close();
      }
    }
  }, [props.Address]);

  // console.log(props.Address, props.SelAddress, "adfsadfas");
  // console.log(City);

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    const CenterAddress = JSON.parse(localStorage.getItem("hospAddr"));
    var token = userFromLocal.token;
    dispatch(
      getCartDetails(token, citySelected?.citySelect, CenterAddress?.id)
    );
  };
  //HANDEL ADD TO CART
  const addtocart = (packageid) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal?.token;

    const body = {
      package: packageid,
    };

    if (token && token !== "" && token) {
      dispatch(AddtoCart(body, token, successCb));
      history.push({
        pathname: `/imaging/cart`,
      });
    } else {
      history.push({
        pathname: "/login",
        pushToUrl: "imaging/cart",
        packageId: packageid,
      });
    }
  };

  const handleClick = (radioVal) => {
    console.log("pressesd", radioVal);
    props.setImgCenterAddress(radioVal?.center_address);
    localStorage.setItem("hospAddr", JSON.stringify(radioVal?.center_address));

    if (fromCart) {
      addtocart(cartId);
    } else {
      history.push({
        pathname: `/imaging/${slug}${
          props.SelCity
            ? `-${props.SelCity.toLowerCase().replace(" ", "-")}`
            : ""
        }`,
      });
    }
  };
  const setInputcity = (val) => {
    setUserCity(val);
    localStorage.setItem("city", val);
    setDisplay(false);
  };
  // const handlecity = (e) => {
  //   const userProfile = JSON.parse(localStorage.getItem("user"));
  //   dispatch(setCity(e.target.value));
  //   console.log(e.target.value, "Top Nav city");
  //   e.target.blur();
  //   userProfile && userProfile !== ""
  //     ? dispatch(EmptyCart(userProfile && userProfile.token, successCd))
  //     : null;
  // };
  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
  };
  return (
    <>
      <div className="AddressDiv">
        <div className="header">
          <div className="pinDiv">Enter City</div>
          <div
            className={userCity ? "cityListNew" : "displayNone"}
            id="cityListNew"
          >
            {userCity !== "" && City && City.cities
              ? City.cities
                  .filter((name) => {
                    if (userCity == "") {
                      return name;
                    } else if (
                      name.toLowerCase().includes(userCity.toLowerCase())
                    ) {
                      return name;
                    }
                  })
                  .map((values, index) => {
                    if (index < 3) {
                      return (
                        <>
                          <div
                            onClick={() => {
                              props.getAddress(props.slug, props.SelCity);
                              setInputcity(values);
                              props.setCity(values);
                            }}
                            key={index}
                            className={
                              displayCityList ? "cityLIstLP" : "displayNone"
                            }
                          >
                            {values}
                          </div>
                        </>
                      );
                    }
                  })
              : null}
          </div>
          <div className="citySelect cityDiv">
            <span className="locIcon">
              {" "}
              <MdLocationOn />{" "}
            </span>

            <input
              style={{ border: "none" }}
              type="text"
              // onBlur={()=> setCityFocus(true)}
              placeholder={props.SelCity?.replace(" ", "-")}
              onChange={handelCityChange}
              value={userCity}
            />
          </div>
          <div className="line"></div>
        </div>
      </div>
      <div className="imagingAddressDiv">
        <div className="packageListofOurPacakages">
          {/* <div> <h2 style={{fontSize:'2rem',padding:'2rem'}}>Most Sold/Booked Tests</h2></div> */}

          {props.Address?.length > 0 ? (
            <div className="availableCentre">
              Redcliffe partner centres
              <div className="selectCentre">
                Select from our world class centres
              </div>
              {props.Address?.map((card) => {
                console.log(
                  "card data",
                  card?.center_address?.center_address?.name
                );
                return (
                  <>
                    <div className="Package__card Package__card2 bgOrdinary bgOrdinary2 " key={card.id}>
                      <div className="packageBottom">
                        <div className="Package__cardTitle">
                          <span className="packageblue">
                            {/* {card?.center_address?.center_address?.name} */}
                          </span>
                        </div>
                        {/* <div className="Package__cardList">{card.listDesc}</div> */}
                        <div className="Package__cardList">
                          Address
                          <span>
                            {card?.center_address?.center_address?.address}
                          </span>
                        </div>
                        <div className="Package__cardPrice priceDiv">
                          Price
                          <span className="price">
                            &#8377; {card.offer_price}
                          </span>
                        </div>

                        {/* </Link> */}
                      </div>
                      <div className=" radio">
                        <div className={card.isPremium ? "pTop" : "oTop"}>
                          <div
                            className="cart_div"
                            // onClick={() => addtocart(card.id)}
                          >
                            <input
                              type="radio"
                              value={radioVal}
                              name="adress"
                              onClick={() => {
                                setRadioVal(card);
                              }}
                              // checked={this.state.selectedOption === "city1"}
                              //   onChange={this.onValueChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          ) : (
            <div className="availableCentre" style={{ marginBottom: "1rem" }}>
              No centre available for the selected city
            </div>
          )}
        </div>
      </div>
      <div
        className="btn"
        style={{ display: "flex", justifyContent: "center", marginLeft: "0" }}
      >
        <button
          disabled={radioVal == ""}
          className={radioVal ? "addressBtn" : "disBtn"}
          onClick={() => {
            handleClick(radioVal);
          }}
        >
          Submit
        </button>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  Address: state?.getImgPackagesAddressReducer?.ImgPackagesAddress,
  City: state?.navCityList?.navCities,
  SelCity: state?.cityOnTopNav?.citySelect,
  SelAddress: state?.setImgCenterAddressReducer?.CenterAddress,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getAddress: (packageName, city) => {
      dispatch(getAddressImagingPackageList(packageName, city));
    },
    setCity: (city) => {
      dispatch(setCity(city));
    },
    setImgCenterAddress: (CenterAddress) => {
      dispatch(setImgCenterAddress(CenterAddress));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddressPopUp);
